var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('charity-call'),_c('charity-call-mobile-title'),_c('about-section'),_c('campaign-results'),_c('what-we-do'),_c('nft'),_c('quote'),_c('foundation-details'),_c('our-donators'),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }